<template>
  <layout-quarter bg="/images/photo-9.jpg">
    <h1 class="heading h2 t-inverse t-center">
      Where would you like your property to be located?
    </h1>

    <div class="button-group">
      <button-expand v-for="province in provinces" :key="province.Id" :province="province"></button-expand>
    </div>

    <router-link class="button" to="price-range" :disabled="!filters.towns.length">Next</router-link>
    <a class="button button--link" @click="$router.back()">Back</a>
  </layout-quarter>
</template>

<style scoped lang="scss">
  
</style>

<script>
  import { mapState, mapGetters } from 'vuex';
  import LayoutQuarter from '@/layouts/Quarter';
  import ButtonExpand from '@/components/ButtonExpand';

  export default {
    name: 'PropertyType',

    components: {
      LayoutQuarter,
      ButtonExpand
    },

    computed: {
      ...mapState([
        'provinces',
        'filters'
      ])
    }
  };
</script>